import { useContext, useState } from 'react';

import { Add, Bookmark, DeleteOutlined, ExpandMore, FileDownload } from '@mui/icons-material';
import { Box, Button, Paper } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import Dialog from '@/components/Dialog';
import { SPOT_CATALOG_PATH } from '@/constants/constants';
import { useAppDispatch } from '@/hooks/redux-hooks';
import useDataHubSelector from '@/pages/DataHub/useDataHubSelector';
import { setSymbols } from '@/slices/symbolSelectorSlice';

import DataHubsDropdown from './DataHubsDropdown';
import { NavigationContext } from './NavigationContext';
import { RootState } from '../../store';

const DataHubActionBar = ({ activeTab, disabled }: { activeTab: number; disabled: boolean }) => {
  const navigate = useNavigate();
  const { navigateToDataHub } = useContext(NavigationContext);
  const dispatch = useAppDispatch();

  const { dataHubs, activeDataHubId } = useSelector((state: RootState) => state.dataHub);
  const { name = '', symbols = [] } =
    dataHubs.find(dataHub => dataHub.id === activeDataHubId) || {};

  const { deleteDataHub } = useDataHubSelector();
  const [confirmClearDialogOpen, setConfirmClearDialogOpen] = useState(false);
  const dropdownButtonContent = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 158
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Bookmark sx={{ fontSize: 16, mr: 1 }} />
        All Data Hubs
      </Box>
      <ExpandMore sx={{ mr: '0!important' }} />
    </Box>
  );
  return (
    <>
      <Paper sx={{ mt: 3, px: 2, py: 1, display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
          <DataHubsDropdown
            buttonContent={dropdownButtonContent}
            buttonVariant='outlined'
            disabled={disabled}
          />
          <Button
            disabled={!activeDataHubId || disabled}
            sx={{ ml: 2, width: 188 }}
            variant='outlined'
            onClick={() => {
              setConfirmClearDialogOpen(true);
            }}
          >
            <DeleteOutlined />
            Delete this Data Hub
          </Button>
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
          {[0].includes(activeTab) && (
            <Button
              disabled={!symbols.length || disabled}
              sx={{ width: 188, mr: 2 }}
              variant='outlined'
              onClick={() => dispatch(setSymbols(symbols))}
            >
              <Box sx={{ width: 14, height: 14, backgroundColor: 'primary.main', mr: 0.5 }} />
              Back to selector
            </Button>
          )}
          {[1, 2].includes(activeTab) && (
            <Button
              disabled={!symbols.length || disabled}
              sx={{ width: 188, mr: 2 }}
              variant='outlined'
              onClick={() => {
                navigateToDataHub(3);
              }}
            >
              <FileDownload />
              Export data
            </Button>
          )}
          <Button
            disabled={disabled}
            sx={{ width: 188 }}
            variant='outlined'
            onClick={() => navigate(`/catalog/${SPOT_CATALOG_PATH}`)}
          >
            <Add />
            Select more
          </Button>
        </Box>
      </Paper>
      <Dialog
        hasCancelButton
        actionButtonText='Delete Data Hub'
        handleAction={() => {
          deleteDataHub(activeDataHubId);
          navigateToDataHub(0);
          setConfirmClearDialogOpen(false);
        }}
        handleClose={() => {
          setConfirmClearDialogOpen(false);
        }}
        open={confirmClearDialogOpen}
        text={
          <>
            Delete '{name}' Data Hub?
            <br />
            <br />
            You will permanently lose this saved Data Hub.
          </>
        }
      />
    </>
  );
};

export default DataHubActionBar;
